import { CommApiInstance } from "Utils/CommApiInstance";


const MembLvdCnclApi = async (
) => {
    return await CommApiInstance.post(`memb/lvd/cncl`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default MembLvdCnclApi;